export const endpoints = {
  getFeatureFlags: (featureFlags: string[]) => `/feature_flags?names=${featureFlags.join()}`,
  tokenInfo: () => "/oauth/token/info"
};
